module.exports = __webpack_public_path__ + "img/sty_1.69bbdfe6.webp";